export enum VersionStatus {
    Supported = 'supported',
    Unsupported = 'unsupported',
}

export interface Version {
    id: number;
    version: string;
    status: VersionStatus;
    createdAt: string;
    updatedAt: string;
}
